import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesResolutionsTranslationsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-resolutions-translations',
	path: '/secure/admin/ViewTranslations!default.jspa',
	query: ['issueConstantType=resolution'],
};
